import { createFileRoute } from "@tanstack/react-router";
import { ActionGroupList } from "@/components/action-groups/ActionGroupList";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/action-groups/")({
	component: ActionGroupsListPage,
});

function ActionGroupsListPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="min-h-screen bg-muted/30 p-6">
				<div className="mx-auto max-w-7xl space-y-6">
					<p className="text-muted-foreground">
						No campaign found. Please complete onboarding first.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-muted/30">
			<div className="mx-auto max-w-7xl">
				<ActionGroupList campaignId={campaignId} />
			</div>
		</div>
	);
}
